require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 796
// module chunks = 0